import "./CategoryNotFound.scss";
import { motion } from "framer-motion";
import { Link } from "wouter";

export function CategoryNotFound() {
	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.3, ease: [0.39, 0.39, 0.69, 0.69] }}
			className="category-not-found">
			<div className="category-not-found__container">
				<h1 className="category-not-found__title">Page not found</h1>
				<div className="category-not-found__content">
					<p>We’re sorry, the page you are looking for was not found.</p>
				</div>
				<div>
					<Link href="/">Back to the Virtual Economy Technology Radar</Link>
				</div>
			</div>
		</motion.div>
	);
}
